/* global eventDelegate:true */

const LOADING = 'carousel--loading';
const TITLE = '.typo__h3--fat';

class AjaxSlider {
    constructor(context) {
        this.context = context;

        // на главной некоторые слайдеры не показываются в телефоне
        if (MNTK.device.isMobile && context.hasAttribute('data-mobile-skip')) {
            return;
        }

        const init = () => {
            this.init();
        };

        window.MNTK.execInIdleCallback(init);
    }

    init() {
        const url = Routing.generate('api.web.goods.recommendations.html', {
            list:     this.context.getAttribute('data-list'),
            argument: this.context.getAttribute('data-argument'),
            slides:   this.context.getAttribute('data-slides'),
            lazy:     this.context.getAttribute('data-lazy'),
        });

        const customHeader = MNTK.isAcceptWebp
            ? {'Accept': 'text/html,application/xhtml+xml,application/xml,image/webp'}
            : {}
        ;

        MNTK.makeRequest('GET', url, null, customHeader)
            .then(html => this.renderSliders(html))
            .catch(console.log);
    }

    renderSliders(html) {
        this.context.innerHTML = html;
        this.renderButton();

        const slides = this.context.getAttribute('data-slides');
        new window.MNTK.Carousel(this.context, slides ? { slides } : null);

        MNTK.emit('updateLazyLoad');
        this.context.classList.remove(LOADING);

        MNTK.emit('updateMerchandisingTrackedElements');

    }

    renderButton() {
        if (MNTK.isBlackFriday) return;
        if (MNTK.deviceType === 'm') return;

        const href = this.context.getAttribute('data-href');
        if (!href) return;

        const $title = this.context.querySelector(TITLE);
        if (!$title) return;

        $title.innerHTML += this.renderLink(href);
    }

    renderLink(href) {
        return `<a href="${href}" class="button--white">Смотреть ещё</a>`;
    }
}

export default AjaxSlider;
